import { useState, useEffect } from 'react';
import { useMfeVersionManager } from './use-mfe-version-manager';

/**
 * A React hook to get the current version for a specific Micro-Frontend (MFE).
 *
 * This hook retrieves the version from the global MFEVersionManager instance.
 * It will also automatically update the version if it's changed elsewhere
 * in the application by listening for a custom 'mfe-versions-updated' event.
 *
 * @param mfeName The name of the MFE (e.g., 'scheduling-ui').
 * @returns The version string for the MFE.
 */
export function useMfeUrl(mfeName: string): string | null {
  const [mfeUrl, setMfeUrl] = useState<string | null>(null);
  const versionManager = useMfeVersionManager();

  useEffect(() => {
    const update = () => {
      if (versionManager) {
        setMfeUrl(versionManager.getResolvedUrl(mfeName));
      }
    };

    // Initial version fetch
    update();
  }, [versionManager, mfeName]);

  return mfeUrl;
}
